/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import "./styles.scss";

// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'toggle-switch';

/**
 * This is the component description.
 */
const ToggleSwitch = ({
  id,
  className: userClassName,
  style,
  handleOnChange,
  checked,
  size,
  inputId
  // ...otherProps
}) => /*#__PURE__*/React.createElement("button", {
  id: id,
  className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
  style: {
    '--size': size,
    ...style
  },
  type: "button"
  // {...otherProps}
}, /*#__PURE__*/React.createElement("input", {
  type: "checkbox",
  id: inputId,
  checked: checked,
  onChange: handleOnChange
}), /*#__PURE__*/React.createElement("label", {
  htmlFor: inputId
}));
ToggleSwitch.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * The onClick handler for this element
   */
  handleOnChange: PropTypes.func,
  /**
   * The checked state of this element
   */
  checked: PropTypes.bool,
  /**
   * The size of this element
   */
  size: PropTypes.string,
  /**
   * The ID of the elelment to be toggled
   */
  inputId: PropTypes.string.isRequired
};
ToggleSwitch.defaultProps = {
  // someProp: 'someValue',
};
export default ToggleSwitch;